import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.attendance.confirm');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;
declare const WizRoute: any;

@Component({
    selector: 'wiz-page-attendance-confirm',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.attendance.confirm/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageAttendanceConfirmComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = true;
    public errorMsg: string = '';
    public token: string = '';
    public request: any = null;
    public session: any = null;
    public program: any = null;

    public form: any = {
        response_status: '',
        attendee_name: '',
        attendee_position: '',
        attendee_phone: '',
        attendee_email: '',
        note: '',
    };
    public submitted: boolean = false;
    public submitting: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        this.token = (WizRoute.segment && WizRoute.segment.token) || '';
        if (!this.token) {
            this.errorMsg = '잘못된 접근입니다. 메일에 포함된 링크를 다시 확인해주세요.';
            this.loading = false;
            await this.service.render();
            return;
        }
        const r = await wiz.call('verify', { token: this.token });
        if (r.code != 200) {
            this.errorMsg = r.data?.message || '유효하지 않은 링크입니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        this.request = r.data.data.request;
        this.session = r.data.data.session;
        this.program = r.data.data.program;
        // 이전 응답 채우기
        if (this.request.response_status && this.request.response_status !== 'pending') {
            this.form = {
                response_status: this.request.response_status,
                attendee_name: this.request.attendee_name || '',
                attendee_position: this.request.attendee_position || '',
                attendee_phone: this.request.attendee_phone || '',
                attendee_email: this.request.attendee_email || '',
                note: this.request.note || '',
            };
        } else {
            this.form.attendee_name = this.request.recipient_name || '';
            this.form.attendee_email = this.request.recipient_email || '';
        }
        this.loading = false;
        await this.service.render();
    }

    public async submit() {
        if (!this.form.response_status) {
            alert('참석 여부를 선택해주세요.');
            return;
        }
        if (this.form.response_status === 'attending') {
            if (!this.form.attendee_name?.trim()) {
                alert('참석자명을 입력해주세요.');
                return;
            }
        }
        this.submitting = true;
        await this.service.render();
        const r = await wiz.call('submit', {
            token: this.token,
            data: JSON.stringify(this.form),
        });
        this.submitting = false;
        if (r.code != 200) {
            alert(r.data?.message || '제출 중 오류가 발생했습니다.');
            await this.service.render();
            return;
        }
        this.submitted = true;
        await this.service.render();
    }
}

export default PageAttendanceConfirmComponent;